import React from "react";
import { Input } from "antd";
import { Label } from "../globals";

const TextInputModal = (props) => {
  const renderErrors = () => {
    return props.error.map((err, index) => {
      if (props.error.length - 1 == index) {
        return <span>{err}</span>;
      }
      return <span className="mr-1">{err},</span>;
    });
  };
  return (
    <>
      {props.text && (
        <Label
          className="text-sm-label"
          required={props.required}
          error={props.error || props.warning}
        >
          {props.subText ? (
            <div className="d-flex justify-content-between align-items-center">
              {props.text}
              {props.subText && (
                <div className="text-xs text-silver">({props.subText})</div>
              )}
            </div>
          ) : (
            props.text
          )}
        </Label>
      )}

      <Input
        autoComplete="dummy-no-auto-complete-fix"
        type={props.type || "text"}
        step={props.step}
        min={props.min}
        className={`orange ${
          props.warning || props.error ? "error_border" : ""
        }`}
        showCount={props.maxLength ? true : false}
        maxLength={props.maxLength}
        style={props.style}
        name={props.name || ""}
        placeholder={props.placeholder || "Type in"}
        onKeyDown={props.onKeyDown}
        onPressEnter={props.onPressEnter}
        value={props.value}
        onFocus={props.onFocus}
        onChange={props.onChange}
        disabled={props.disabled}
        suffix={props.suffix}
      />
      {props.warning && <div className="text-danger">{props.warning}</div>}
      {props.error && <div className="text-danger">{renderErrors()}</div>}
    </>
  );
};

TextInputModal.defaultProps = {
  placeholder: "Type in",
};

export default TextInputModal;
